/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid200,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse,
  PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid.ts";
import { classroomDisciplineIdsViewModelSchema } from "../classroomDisciplineIdsViewModelSchema.ts";

export const postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParamsSchema =
  z.object({
    classModuleId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid200Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid500>;

export const postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequestSchema =
  z.lazy(
    () => classroomDisciplineIdsViewModelSchema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationRequest>;

export const postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponseSchema =
  z.lazy(
    () =>
      postApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleid200Schema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidMutationResponse>;
